import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Chart } from 'chart.js';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B01DashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b01-dashboard',
  templateUrl: 'b01-dashboard.html',
})
export class B01DashboardPage {

  // <Chart>
  @ViewChild('barCanvas') barCanvas;
  @ViewChild('doughnutCanvas') doughnutCanvas;
  @ViewChild('lineCanvas') lineCanvas;
  @ViewChild('barCanvas_fuelPrice') barCanvas_fuePrice;

  loading: any;
  Status: any;
  barChart: any;
  doughnutChart: any;
  lineChart: any;
  barChart_fuelPrice: any;
  GRP_ID: any;
  public errorMessage: any = "";
  TotalBranch: any;
  TotalInventory: any;
  DailySales: any;
  MonthlySales: any;
  BranchAnnualSales: any;
  BranchMonthlySales: any;
  CorporateMonthlySales: any;
  ListInventory: any;
  current_branch:any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {

    
    this.GRP_ID = sessionStorage.getItem('usergroupid');

    if (this.GRP_ID == "1") {                               //system_admin dashboard info request

        this.showLoader();
        this.serviceapi.dashboarddata('Admin', 'Admin').then((result) => {
            this.loading.dismiss();
            this.Status = result["Message"];
            if (this.Status == '1'){
              
                 this.TotalBranch = result["TotalBranch"];
                this.TotalInventory = result["TotalInventory"];
                this.DailySales = result["DailySales"];
                this.MonthlySales = result["MonthlySales"];

                this.BranchAnnualSales = result["BranchAnnualSales"];
                this.BranchMonthlySales = result["BranchMonthlySales"];
                this.CorporateMonthlySales = result["CorporateMonthlySales"];
                this.ListInventory = result["ListInventory"];

                //console.log(">>"+ JSON.stringify(this.CorporateMonthlySales[0]));
/*                 this.CorporateMonthlySales = this.CorporateMonthlySales[0].RHTRADING; */
                //var idx = 1; // key2
                let i=0;
                let Corporate = [];
                let Corporate_Val = [];
                let New_Corporate = [];
                for(i=0;i<(this.CorporateMonthlySales).length;i++)
                {
                    let abc = this.CorporateMonthlySales[i];
                    let key = Object.keys(abc)[0];

                    let Corp = {Name:"",Val:""};
                    Corp.Name = key;
                    Corp.Val = abc[key];
                    //Corporate.push(key);
                    let value = abc[key];
                    //Corporate_Val.push(value);
                    New_Corporate.push(Corp);
                }
                New_Corporate.sort(this.GetSortOrder("Val"));
                console.log(New_Corporate);
                let newcount=0;
                for(newcount=0;newcount<10;newcount++)
                {
                    Corporate.push(New_Corporate[newcount]["Name"]);
                    Corporate_Val.push(New_Corporate[newcount]["Val"]);
                }
                //Corporate Sales
                this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
 
                    type: 'doughnut',
                    data: {
                        labels: Corporate,
                        datasets: [{
                            label: 'Sales Value',
                            data: Corporate_Val,
                            backgroundColor: [
                              'rgba(255, 99, 132, 0.2)',
                              'rgba(54, 162, 235, 0.2)',
                              'rgba(255, 206, 86, 0.2)',
                              'rgba(48, 255, 58, 0.2)',
                              'rgba(153, 102, 255, 0.2)',
                              'rgba(255, 159, 64, 0.2)',
                              'rgba(196, 196, 196, 0.2)',
                            ],
                            hoverBackgroundColor: [
                              'rgba(255,99,132,1)',
                              'rgba(54, 162, 235, 1)',
                              'rgba(255, 206, 86, 1)',
                              'rgba(48, 266, 58, 1)',
                              'rgba(153, 102, 255, 1)',
                              'rgba(255, 159, 64, 1)',
                              'rgba(196, 196, 196, 1)',
                            ]
                        }]
                    }
              
                  });


                  //Branch Sales
                  let j=0;
                  let Branch = [];
                  let Branch_Val = [];
                  for(j=0;j<(this.BranchMonthlySales).length;j++)
                  {
                      let abc = this.BranchMonthlySales[j];
                      let key = Object.keys(abc)[0];
                      Branch.push(key);
                      let value = abc[key];
                      Branch_Val.push(value);
                  }
                  this.barChart = new Chart(this.barCanvas.nativeElement, {
  
                    type: 'bar',
                    data: {
                        labels: Branch,
                        datasets: [{
                            label: '# of Sales',
                            data: Branch_Val,
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)'
                                /*,
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)',
                                'rgba(196, 196, 196, 0.2)',
                                'rgba(200, 48, 148, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(247, 255, 20, 0.2)'*/
                            ],
                            borderColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)'
                                /*,
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(48, 266, 58, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                                'rgba(196, 196, 196, 1)',
                                'rgba(200,48,148,1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(247, 255, 20, 1)'*/
                            ],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero:true
                                }
                            }]
                        }
                    }
              
                  });
                  let k=0;
                  let l=0;
                  var Branch_Name=[];
                  var Branch_Data = [] ;
                  //let Branch_Val = [];
                  for(l=0;l<Branch.length;l++)
                  {
                    var Annual_Data = [] ;
                    for(k=0;k<(this.BranchAnnualSales).length;k++)
                    {
                        let abc = this.BranchAnnualSales[k];
                        let key = Object.keys(abc)[0];
                       // console.log(key);
                        let value = abc[key];
                        //let m =0;
                        //for(m=0;m<value.length;m++)
                        //{
                            let data = value[l];
                            let branch = Object.keys(data)[0];
                            console.log(branch);
                            Branch_Name[l] = branch;
                            let branchval = data[branch];
                            (Annual_Data).push(branchval);
                            //Branch_Val.push(value);
                        //}
  
                        //console.log(value);
                        //Branch_Val.push(value);
                    }
                    Branch_Data[l] = Annual_Data;
                  }
                  
                 
                  
                var newjson=[];
                let n =0;
                for(n=0;n<Branch_Name.length;n++)
                {
                    let linechartjson = {
                        label: "",
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: "rgba(75,192,192,0.4)",
                        borderColor: "rgba(75,192,192,1)",
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: "rgba(75,192,192,1)",
                        pointBackgroundColor: "#fff",
                        pointBorderWidth: 1,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: "rgba(75,192,192,1)",
                        pointHoverBorderColor: "rgba(220,220,220,1)",
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [],
                        spanGaps: false,
                    }
                    let color = [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(48, 255, 58, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)',
                        'rgba(196, 196, 196, 0.2)',
                        'rgba(200, 48, 148, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(247, 255, 20, 0.2)'
                    ]

                    linechartjson.label = Branch_Name[n];
                    linechartjson.data = Branch_Data[n];
                    linechartjson.backgroundColor = color[n];
                    linechartjson.borderColor= color[n];
                    linechartjson.pointBorderColor= color[n];
                    linechartjson.pointHoverBackgroundColor= color[n];
                    linechartjson.pointHoverBorderColor= color[n];
                    newjson.push(linechartjson);
                    

                }
                //console.log(newjson);
                  
                  this.lineChart = new Chart(this.lineCanvas.nativeElement, {

                    type: 'line',
                    data: {
                        labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        datasets: newjson
                    }
            
                });


                let p=0;
                let Inventory = [];
                let Inventory_Cost = [];
                //let Branch_Val = [];
                for(p=0;p<(this.ListInventory).length;p++)
                {
                    let abc = this.ListInventory[p];
                    let key = Object.keys(abc)[0];
                    //Branch.push(key);
                    let value = abc[key];
                    console.log(value);
                    let m =0;
                    for(m=0;m<value.length;m++)
                    {
                        let xyz = value[m];
                        let mydata = Object.keys(xyz)[0];
                        //Branch.push(key);
                        Inventory.push(xyz["ITEM_DESC"]);
                        Inventory_Cost.push(xyz["SELLING_PRICE"]);
                    }
                    //Inventory.push(value[]);
                }
                this.barChart_fuelPrice = new Chart(this.barCanvas_fuePrice.nativeElement, {
  
                    type: 'bar',
                    data: {
                        labels: Inventory,
                        datasets: [{
                            label: '# of Sales',
                            data: Inventory_Cost,
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)'
                            ],
                            borderColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 99, 132, 0.2)'
                            ],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero:true
                                }
                            }]
                        }
                    }
              
                  });
                //var key = Object.keys(this.CorporateMonthlySales)[idx];
                //var value = this.CorporateMonthlySales[key]
                //var value2 = this.getMapValue(this.CorporateMonthlySales,key);
                
                //console.log(key);
                //console.log(key,value);
                //console.log(value2);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
        }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
        });
    } 
    else if (this.GRP_ID == "2" || this.GRP_ID == "3"  || this.GRP_ID == "4"  || this.GRP_ID == "5" ) {   
        this.showLoader();
        
        this.serviceapi.dashboarddata('Branch', '1').then((result) => {
            this.loading.dismiss();
            this.Status = result["Message"];
            console.log("xxxx"+sessionStorage.getItem('userbranchid'));
            if (this.Status == '1'){
              
                let tbl = ["BRANCH"];
                let column = ["BRANCH_ID"];
                let value = [sessionStorage.getItem('userbranchid')];
            
                let tblkey = ["No"];
                let fktbl = ["No"];
                let fkkey = ["No"];
              
                let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      
                let mydata = Object.assign(jsonitem);
                let json_data = this.serviceapi.json_readdata(mydata,"1");
               
            
                this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result1) => {
                  
                    let Status1= result1["Message"];
                    if (Status1 == '1'){
                      
                      let Records1 = result1["Records"];
                      console.log(Records1);
                      this.current_branch = Records1[0]["BRANCH_NAME"];
                      console.log("ABC"+this.current_branch);
                   


                    this.TotalBranch = result["TotalBranch"];
                    this.TotalInventory = result["TotalInventory"];
                    this.DailySales = result["DailySales"];
                    this.MonthlySales = result["MonthlySales"];

                    this.BranchAnnualSales = result["BranchAnnualSales"];
                    
                    this.BranchMonthlySales = result["BranchMonthlySales"];
                    this.CorporateMonthlySales = result["CorporateMonthlySales"];
                    this.ListInventory = result["ListInventory"];

                    //console.log(">>"+ JSON.stringify(this.CorporateMonthlySales[0]));
    /*                 this.CorporateMonthlySales = this.CorporateMonthlySales[0].RHTRADING; */
                    //var idx = 1; // key2
                    let i=0;
                    let Corporate = [];
                    let Corporate_Val = [];
                    let New_Corporate = [];
                    for(i=0;i<(this.CorporateMonthlySales).length;i++)
                    {
                        let abc = this.CorporateMonthlySales[i];
                        let key = Object.keys(abc)[0];

                        let Corp = {Name:"",Val:""};
                        Corp.Name = key;
                        Corp.Val = abc[key];
                        //Corporate.push(key);
                        let value = abc[key];
                        //Corporate_Val.push(value);
                        New_Corporate.push(Corp);
                    }
                    New_Corporate.sort(this.GetSortOrder("Val"));
                    console.log(New_Corporate);
                    let newcount=0;
                    for(newcount=0;newcount<10;newcount++)
                    {
                        Corporate.push(New_Corporate[newcount]["Name"]);
                        Corporate_Val.push(New_Corporate[newcount]["Val"]);
                    }
                    //Corporate Sales
                    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
    
                        type: 'doughnut',
                        data: {
                            labels: Corporate,
                            datasets: [{
                                label: 'Sales Value',
                                data: Corporate_Val,
                                backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(54, 162, 235, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(48, 255, 58, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)',
                                'rgba(196, 196, 196, 0.2)',
                                ],
                                hoverBackgroundColor: [
                                'rgba(255,99,132,1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(48, 266, 58, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                                'rgba(196, 196, 196, 1)',
                                ]
                            }]
                        }
                
                    });


                    //Branch Sales
                    let j=0;
                    let Branch = [];
                    let Branch_Val = [];
                    let Branch1 = [];
                    let Branch_Val1 = [];
                    for(j=0;j<(this.BranchMonthlySales).length;j++)
                    {
                        let abc = this.BranchMonthlySales[j];
                        
                        let key = Object.keys(abc)[0];
                        if(key == this.current_branch)
                        {
                        Branch1.push(key);
                        let value = abc[key];
                        Branch_Val1.push(value);
                        }
                        Branch.push(key);
                        let value = abc[key];
                        Branch_Val.push(value);
                        console.log("zzz"+key+"--"+this.current_branch);
                    }
                    this.barChart = new Chart(this.barCanvas.nativeElement, {
    
                        type: 'bar',
                        data: {
                            labels: Branch1,
                            datasets: [{
                                label: '# of Sales',
                                data: Branch_Val1,
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)'
                                ],
                                borderColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)'
                                ],
                                borderWidth: 1
                            }]
                        },
                        options: {
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero:true
                                    }
                                }]
                            }
                        }
                
                    });
                    let k=0;
                    let l=0;
                    var Branch_Name=[];
                    var Branch_Data = [] ;
                    let count = 0;
                    //let Branch_Val = [];
                    for(l=0;l<Branch.length;l++)
                    {
                        if(Branch[l] == this.current_branch)
                        {
                            
                            var Annual_Data = [] ;
                            for(k=0;k<(this.BranchAnnualSales).length;k++)
                            {
                                let abc = this.BranchAnnualSales[k];
                                let key = Object.keys(abc)[0];
                            
                                let value = abc[key];
                              
                                let data = value[l];
                                let branch = Object.keys(data)[0];
                                console.log("zz"+branch);
                                Branch_Name[count] = branch;
                               
                                let branchval = data[branch];
                                (Annual_Data).push(branchval);
                                   
                            }
                            Branch_Data[count] = Annual_Data;
                        }
                    }
                    
                    
                   
                    var newjson=[];
                    let n =0;
                    for(n=0;n<Branch_Name.length;n++)
                    {
                        let linechartjson = {
                            label: "",
                            fill: false,
                            lineTension: 0.1,
                            backgroundColor: "rgba(75,192,192,0.4)",
                            borderColor: "rgba(75,192,192,1)",
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "rgba(75,192,192,1)",
                            pointBackgroundColor: "#fff",
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: "rgba(75,192,192,1)",
                            pointHoverBorderColor: "rgba(220,220,220,1)",
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: [],
                            spanGaps: false,
                        }
                        let color = [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(48, 255, 58, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(196, 196, 196, 0.2)',
                            'rgba(200, 48, 148, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(247, 255, 20, 0.2)'
                        ]

                        linechartjson.label = Branch_Name[n];
                        linechartjson.data = Branch_Data[n];
                        linechartjson.backgroundColor = color[n];
                        linechartjson.borderColor= color[n];
                        linechartjson.pointBorderColor= color[n];
                        linechartjson.pointHoverBackgroundColor= color[n];
                        linechartjson.pointHoverBorderColor= color[n];
                        newjson.push(linechartjson);
                        

                    }
                    //console.log(newjson);
                    
                    this.lineChart = new Chart(this.lineCanvas.nativeElement, {

                        type: 'line',
                        data: {
                            labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                            datasets: newjson
                        }
                
                    });


                    let p=0;
                    let Inventory = [];
                    let Inventory_Cost = [];
                    //let Branch_Val = [];
                    for(p=0;p<(this.ListInventory).length;p++)
                    {
                        let abc = this.ListInventory[p];
                        let key = Object.keys(abc)[0];
                        //Branch.push(key);
                        let value = abc[key];
                        console.log(value);
                        let m =0;
                        for(m=0;m<value.length;m++)
                        {
                            let xyz = value[m];
                            let mydata = Object.keys(xyz)[0];
                            //Branch.push(key);
                            Inventory.push(xyz["ITEM_DESC"]);
                            Inventory_Cost.push(xyz["SELLING_PRICE"]);
                        }
                        //Inventory.push(value[]);
                    }
                    this.barChart_fuelPrice = new Chart(this.barCanvas_fuePrice.nativeElement, {
    
                        type: 'bar',
                        data: {
                            labels: Inventory,
                            datasets: [{
                                label: '# of Sales',
                                data: Inventory_Cost,
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)'
                                ],
                                borderColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 99, 132, 0.2)'
                                ],
                                borderWidth: 1
                            }]
                        },
                        options: {
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero:true
                                    }
                                }]
                            }
                        }
                
                    });
                    }
                    else {
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                    }
                }, (err) => {
                    this.errorMessage = "Loading Error. Please try again.";
                
                });
                //var key = Object.keys(this.CorporateMonthlySales)[idx];
                //var value = this.CorporateMonthlySales[key]
                //var value2 = this.getMapValue(this.CorporateMonthlySales,key);
                
                //console.log(key);
                //console.log(key,value);
                //console.log(value2);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
        }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
        });
    }
    
    //http://www.rhtyre.com/api/functions/gen_dashboard.php?User=Admin&Id=Admin
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad B01DashboardPage');

    //Chart
    
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  GetSortOrder(prop) {    
        return function(a, b) {    
            if (a[prop] > b[prop]) {    
                return -1;    
            } else if (a[prop] < b[prop]) {    
                return 1;    
            }    
            return 0;    
        }    
    }  
}



// WEBPACK FOOTER //
// ./src/pages/b01-dashboard/b01-dashboard.ts